import { Outlet } from 'react-router-dom';
import { TabBar } from './TabBar';
import { useTabBadge } from '@/hooks/useInboxData';
import { useCallsBadge, useCallsLive } from '@/hooks/useCallsData';
import { useCalendarBadge } from '@/hooks/useCalendarData';

/** Оболочка с нижним меню. Экраны рисуются в Outlet, у каждого своя защита от сбоя. */
export function AppShell() {
  // Значок «Входящие»: непрочитанные переписки, которые ведёт человек или никто (см. useTabBadge).
  const inboxBadge = useTabBadge();
  // «Звонки»: мои пропущенные без перезвона + итоги, ждущие решения; «Календарь»: просрочено + сегодня (мои).
  const callsBadge = useCallsBadge();
  const calendarBadge = useCalendarBadge();
  // Живая лента CRM держит «Звонки» и календарь свежими, даже когда открыт другой раздел (значки).
  useCallsLive();
  return (
    <div className="app-root">
      <main className="flex-1 min-h-0 flex flex-col relative">
        <Outlet />
      </main>
      <TabBar badges={{ '/inbox': inboxBadge, '/calls': callsBadge, '/calendar': calendarBadge }} />
    </div>
  );
}
